export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_LOGIN_PURGE = 'AUTH_LOGIN_PURGE';
export const API_AUTH_REDIRECT_RESET = 'API_AUTH_REDIRECT_RESET';
/**
 * ログイン action (Saga watch)
 * @param payload
 * @param meta
 * @returns
 */
export const authLogin = (payload, meta) => ({
    meta,
    payload,
    type: AUTH_LOGIN,
});
/**
 * リダイレクト リセット
 */
export const authRedirectReset = () => ({
    type: API_AUTH_REDIRECT_RESET,
});
